/**
 * Monta o contexto mínimo de análise para exportação PDF/Excel
 * a partir das medições do DashMedidas (limites padrão 13.5–14.5%).
 */
export const buildDashMedidasExportContext = (
  data = [],
  limits = { min: 13.5, max: 14.5 }
) => {
  const rows = Array.isArray(data) ? data : [];
  const withoutRotation = rows.filter(
    (item) => !(item.rotation === true || item.rotation === "true")
  );

  const exactRange = withoutRotation.filter((item) => {
    const humidity = parseFloat(item.humidity);
    return humidity >= limits.min && humidity <= limits.max;
  });

  const belowRange = withoutRotation.filter((item) => {
    const humidity = parseFloat(item.humidity);
    return humidity < limits.min;
  });

  const aboveRange = withoutRotation.filter((item) => {
    const humidity = parseFloat(item.humidity);
    return humidity > limits.max;
  });

  const meanForRange = (range) => {
    if (!range.length) return 0;
    const sum = range.reduce(
      (acc, item) => acc + parseFloat(item.humidity),
      0
    );
    return (sum / range.length).toFixed(1);
  };

  const exact = exactRange.length;
  const below = belowRange.length;
  const above = aboveRange.length;
  const totalSlices = exact + below + above;
  const safeTotal = totalSlices > 0 ? totalSlices : 1;

  return {
    data: withoutRotation,
    limits,
    mean: {
      exactMean: meanForRange(exactRange),
      belowMean: meanForRange(belowRange),
      aboveMean: meanForRange(aboveRange),
      highMean: 0,
    },
    stats: {
      exact,
      below,
      above,
      high: 0,
      total: withoutRotation.length,
      getPercentage: (value) => ((value / safeTotal) * 100).toFixed(1),
      totalSlices,
    },
    weight: null,
    weightStats: {
      inRange: 0,
      outRange: 0,
      inRangePercent: "0.0",
      outRangePercent: "0.0",
      financialReturn: 0,
      perdaTotal: 0,
    },
  };
};
